// CondicionesUtilidadesModal.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Box, Tabs, Tab, Button, Table, TableHead, TableRow, TableCell, TableBody, TableContainer, Paper, CircularProgress,Typography } from '@mui/material';

const CondicionesUtilidadesModal = ({ open, onClose, analysisId }) => {
  const server = process.env.REACT_APP_API_ROUTE;
  const key = process.env.REACT_APP_API_KEY;
  const [tabValue, setTabValue] = useState(0);
  const [conditions, setConditions] = useState([]);
  const [utilities, setUtilities] = useState([]);
  const [loadingConditions, setLoadingConditions] = useState(false);
  const [loadingUtilities, setLoadingUtilities] = useState(false);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    if (open && analysisId) {
      // API para condiciones
      console.log(analysisId);
      const fetchConditions = async () => {
        setLoadingConditions(true);
        try {
          const response = await fetch(`${server}/CdmCondicionesEspecialesXMuestraXAnalisis/poranalisis/${analysisId.idTipoAnalisis}`);
          const data = await response.json();
          const conds = data.$values || data || [];
          setConditions(conds);
        } catch (error) {
          console.error('Error al cargar condiciones:', error);
        } finally {
          setLoadingConditions(false);
        }
      };

      // API para utilidades
      const fetchUtilities = async () => {
        setLoadingUtilities(true);
        try {
          const response = await fetch(`${server}/CdmUtilidadesXMuestraXAnalisis/porAnalisis/${analysisId.idTipoAnalisis}`);
          const data = await response.json();
          const utils = data.$values || data || [];
          setUtilities(utils);
        } catch (error) {
          console.error('Error al cargar utilidades:', error);
        } finally {
          setLoadingUtilities(false);
        }
      };

      fetchConditions();
      fetchUtilities();
    }
  }, [open, analysisId]);

  const TabPanel = ({ children, value, index, ...other }) => {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 2 }}>
            {children}
          </Box>
        )}
      </div>
    );
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxHeight: '90vh',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 2,
        overflowY: 'auto'
      }}>
         {analysisId && analysisId.remitido && (
          <Typography variant="subtitle1" color="error" gutterBottom>
            Este análisis es remitido.
          </Typography>
        )}
        <Tabs value={tabValue} onChange={handleTabChange} centered>
          <Tab label="Condiciones" />
          <Tab label="Utilidades" />
        </Tabs>
        <TabPanel value={tabValue} index={0}>
          {loadingConditions ? (
            <CircularProgress />
          ) : (
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Condicion</TableCell>
                    <TableCell>Muestra</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {conditions.length > 0 ? (
                    conditions.map((cond, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{cond.descripcionCondicion}</TableCell>
                        <TableCell>{cond.descripcionMuestra}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={2} align="center">
                        No hay condiciones.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          {loadingUtilities ? (
            <CircularProgress />
          ) : (
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Utilidad</TableCell>
                    <TableCell>Muestra</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {utilities.length > 0 ? (
                    utilities.map((util, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{util.descripcionUtilidad}</TableCell>
                        <TableCell>{util.descripcionMuestra}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={2} align="center">
                        No hay utilidades.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </TabPanel>
        <Box sx={{ mt: 2, textAlign: 'right' }}>
          <Button variant="contained" onClick={onClose}>Cerrar</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default CondicionesUtilidadesModal;
